"use client";
import React, { useRef } from "react";
import { m, useScroll, useTransform } from "motion/react";
import { cn } from "@/lib/utils";

export default function ManifestoSection() {
    return (
        <section
            className="relative min-h-[80vh] py-24 flex flex-col items-center justify-center overflow-hidden"
        >
            {/* <div className="absolute inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]" /> */}

            <div className="absolute inset-0 w-full h-full pointer-events-none">
            </div>

            <m.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.4 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative z-10 max-w-4xl mx-auto px-6 text-center"
            >
                <span className="text-midas-yellow-500 font-mono text-sm tracking-widest uppercase mb-8 block">
                    Destrave o seu potencial digital
                </span>

                <h2 className="text-4xl md:text-6xl font-bold text-white mb-12 leading-tight">
                    Empresas de qualidade não falham por falta de competência técnica.
                </h2>

                <div className="space-y-8 text-lg md:text-2xl text-neutral-400 font-light leading-relaxed">
                    <p>
                        Elas perdem mercado porque sua <strong className="text-white font-semibold">impressão digital</strong> não reflete a excelência do que entregam.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-12 text-left">
                        <Card
                            text="O médico se especializava..."
                            highlight="O concorrente aprendeu a vender online."
                            delay={0.1}
                        />
                        <Card
                            text="O estúdio investia em equipamentos..."
                            highlight="O mercado migrou para o Instagram."
                            delay={0.2}
                        />
                        <Card
                            text="O restaurante melhorava o cardápio..."
                            highlight="Os clientes foram capturados por chatbots."
                            delay={0.3}
                        />
                    </div>

                    <p className="text-3xl md:text-5xl font-bold text-white pt-8">
                        A Midas existe para corrigir essa injustiça.
                    </p>
                </div>
            </m.div>
        </section>
    );
}

function Card({ text, highlight, delay }: { text: string; highlight: string; delay: number }) {
    return (
        <m.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay, duration: 0.5 }}
            className="p-6 rounded-2xl bg-neutral-800/50 border border-neutral-700 hover:border-midas-yellow-500/50 transition-colors"
        >
            <p className="text-neutral-500 text-sm mb-2">{text}</p>
            <p className="text-white font-medium">{highlight}</p>
        </m.div>
    );
}
